// React
import React, { ReactElement, useEffect, useState } from 'react';
// Interface
import { NationalityFilterProps } from '@utmb/types/start-list-table';
import { IconsEnum } from '@utmb/types/icons';
// Design System
import { DropDown } from '@utmb/design-system/dropdown/Dropdown';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
// Styles
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import { Flag } from '@utmb/design-system/flag/Flag';
import ReactSelectFilter from '@utmb/features/react-select-filter/ReactSelectFilter';
import CountryView from '@utmb/types/view/CountryView';

const NationalityFilter = (props: NationalityFilterProps): ReactElement => {
    const { currentNationality, nationalities, selectOptions, setCurrentNationality } = props;
    const { t } = useTranslation();

    const [currentNationalityView, setCurrentNationalityView] = useState<CountryView | null>(null);
    const handleInputNationalityChange = (nationality: any): void => {
        const currentNationalityViewSelected = nationalities.find((countryView) => countryView.code === nationality);

        if (currentNationalityViewSelected && (currentNationalityViewSelected.cio !== currentNationality || currentNationality === '')) {
            setCurrentNationality(currentNationalityViewSelected.cio);
            setCurrentNationalityView(currentNationalityViewSelected);
        } else {
            setCurrentNationality('');
            setCurrentNationalityView(null);
        }
    };

    useEffect(() => {
        if (nationalities) {
            const currentNationalityView = nationalities.find((countryView) => countryView.cio === currentNationality);
            setCurrentNationalityView(currentNationalityView ?? null);
        }
    }, [currentNationality, nationalities]);

    return (
        <div className={styles.toolbar}>
            <DropDown
                className={[styles.drop, styles.dropNationalities].join(' ')}
                button={({ isExpanded }) => (
                    <>
                        <Font.OxaniumMedium mobile="14" desktop="14" className={styles.filter_label}>
                            {currentNationalityView ? (
                                <>
                                    <Flag isoCode={currentNationalityView.code} /> <span>{currentNationalityView.name}</span>
                                </>
                            ) : (
                                t('performanceTable.nationality')
                            )}
                            {/**t('performanceTable.nationality')*/}
                        </Font.OxaniumMedium>
                        <Icon color={'var(--utmb-color-ws-primary)'} variant={IconsEnum[isExpanded ? 'CHEVRON_UP' : 'CHEVRON_DOWN']} />
                    </>
                )}
            >
                <ReactSelectFilter
                    options={selectOptions}
                    selectedOptions={currentNationalityView ? [currentNationalityView.code] : []}
                    handleCheck={handleInputNationalityChange}
                    filterType={'country'}
                    placeholder={t('reactSelectFilter.filterSearchCountry')}
                />
            </DropDown>
        </div>
    );
};

export default NationalityFilter;
